import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustItems = [
    {
      icon: 'Shield',
      text: 'SSL Secured',
      color: 'var(--color-success)'
    },
    {
      icon: 'Lock',
      text: 'Data Encrypted',
      color: 'var(--color-primary)'
    },
    {
      icon: 'Award',
      text: 'Certified Platform',
      color: 'var(--color-accent)'
    }
  ];

  return (
    <div className="mt-6 md:mt-8 flex flex-wrap items-center justify-center gap-4 md:gap-6 lg:gap-8">
      {trustItems?.map((item, index) => (
        <div 
          key={index}
          className="flex items-center gap-2"
        >
          <Icon 
            name={item?.icon} 
            size={18} 
            color={item?.color}
            className="md:w-5 md:h-5"
          />
          <span className="text-xs md:text-sm text-white font-medium">
            {item?.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TrustSignals;